<template>
  <div class="form-container">
    <h2>Registro Mayorista</h2>

    <form @submit.prevent="registrarCliente">
      <div class="form-group">
        <label for="nombre">Nombre completo</label>
        <input type="text" id="nombre" v-model="form.nombre" required />
      </div>

      <div class="form-group">
        <label for="telefono">Teléfono</label>
        <input
          type="text"
          id="telefono"
          v-model="form.telefono"
          placeholder="Ej: 3123456789"
          required
        />
      </div>
      <div class="form-group">
        <label for="correo">Correo electrónico</label>
        <input
          type="email"
          id="correo"
          v-model="form.correo"
          placeholder="Ej: ejemplo@correo.com"
          required
        />
      </div>

      <div class="form-group">
        <label for="nit">Número de documento</label>
        <input type="text" id="nit" v-model="form.nit" required />
      </div>

      <div class="form-group">
        <label for="direccion">Ciudad y Dirección</label>
        <input type="text" id="direccion" v-model="form.direccion" required />
      </div>

      <div class="form-group">
        <label for="fechaNacimiento">Fecha de nacimiento</label>
        <input
          type="date"
          id="fechaNacimiento"
          v-model="form.fechaNacimiento"
          required
        />
      </div>

      <div class="form-group">
        <label for="linea">¿Ya te atiende una línea? (opcional)</label>

        <!-- MOBILE: SELECT -->
        <b-select
          v-if="esMovil"
          v-model="form.idLinea"
          @change="actualizarLineaTexto"
        >
          <option value="">Seleccione una línea (opcional)</option>
          <option
            v-for="usuario in usuariosFiltrados"
            :key="usuario.id"
            :value="usuario.id"
          >
            {{ usuario.usuario }} - {{ usuario.nombre }}
          </option>
        </b-select>

        <!-- DESKTOP: DATALIST -->
        <div v-else>
          <input
            type="text"
            v-model="form.linea"
            list="lineas"
            @change="buscarIdLinea"
            placeholder="Ej: LINEA 1 - Nombre"
          />
          <datalist id="lineas">
            <option
              v-for="usuario in usuariosFiltrados"
              :key="usuario.id"
              :value="usuario.usuario + ' - ' + usuario.nombre"
            />
          </datalist>
        </div>
      </div>

      <button type="submit" :disabled="cargando">
        {{ cargando ? "Registrando..." : "Registrarme" }}
      </button>
    </form>
  </div>
</template>

<script>
import HttpService from "@/Servicios/HttpService";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      cargando: false,
      usuarios: [],
      esMovil: false,
      form: {
        nombre: "",
        telefono: "",
        nit: "",
        direccion: "",
        correo: "",
        fechaNacimiento: "",
        linea: "",
        idLinea: "",
      },
    };
  },
  methods: {
    obtenerUsuarios() {
      this.cargando = true;
      const payload = { accion: "obtener" };
      HttpService.obtenerConConsultas("usuarios.php", payload)
        .then((res) => {
          this.usuarios = res;
          this.cargando = false;
        })
        .catch(() => {
          this.cargando = false;
        });
    },
    registrarCliente() {
      // Validación de teléfono
      if (!/^3\d{9}$/.test(this.form.telefono)) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: "Teléfono inválido",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      // Validación de correo
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.correo.trim())) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: "Correo inválido",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      const seleccionado = this.usuariosFiltrados.find(
        (u) => u.id === parseInt(this.form.idLinea)
      );
      this.form.linea = seleccionado ? seleccionado.usuario : "";

      this.cargando = true;

      const payload = {
        accion: "registrar",
        cliente: this.form,
      };

      HttpService.registrar("clientes.php", payload)
        .then(() => {
          Swal.fire({
            icon: "success",
            title:
              '<span style="font-size: 22px; color: #2c73d2;">¡Registro exitoso!</span>',
            html: `
    <div style="font-size: 15px; color: #1e293b; margin-top: 10px; text-align: left;">
      <p>Tu cuenta ha sido registrada correctamente.</p>
      <p><strong>Usuario:</strong>${this.form.telefono}</p>
      <p><strong>Contraseña:</strong> maxica</p>
      <p style="margin-top: 8px;">
        Puedes iniciar sesión como <strong>mayorista</strong> desde el menú.
      </p>
      <p style="margin-top: 10px;">
        <strong>Recuerda:</strong> la compra mínima inicial para mayoristas es de <strong>4 unidades</strong> de cualquier prenda.
      </p>
      <p style="margin-top: 15px; font-size: 13px; color: #64748b;">
        Serás redirigido automáticamente al inicio...
      </p>
    </div>
  `,
            showConfirmButton: false,
            timer: 8000,
            timerProgressBar: true,
            background: "#ffffff",
            customClass: {
              popup: "swal2-popup-custom",
            },
          });
          this.resetForm();
          this.cargando = false;
          // ✅ Redirige al inicio después de 6 segundos
          setTimeout(() => {
            if (this.$route.path !== "/") {
              this.$router.push("/");
            }
          }, 8000);
        })
        .catch(() => {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Error al registrar. Intenta de nuevo.",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    resetForm() {
      this.form = {
        nombre: "",
        telefono: "",
        nit: "",
        correo: "",
        direccion: "",
        fechaNacimiento: "",
        linea: "",
        idLinea: "",
      };
    },
    actualizarLineaTexto() {
      const seleccionado = this.usuariosFiltrados.find(
        (u) => u.id === parseInt(this.form.idLinea)
      );
      if (seleccionado) {
        this.form.linea = seleccionado ? seleccionado.usuario : "";
      }
    },
    buscarIdLinea() {
      const seleccionado = this.usuariosFiltrados.find(
        (u) =>
          `${u.usuario} - ${u.nombre}`.toLowerCase().trim() ===
          this.form.linea.toLowerCase().trim()
      );
      this.form.idLinea = seleccionado ? seleccionado.id : null;
    },
  },
  mounted() {
    this.obtenerUsuarios();
    this.esMovil = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  },
  computed: {
    usuariosFiltrados() {
      return this.usuarios.filter((u) =>
        u.usuario.toUpperCase().includes("LINEA")
      );
    },
  },
};
</script>

<style scoped>
.form-container {
  max-width: 500px;
  margin: 70px auto;
  padding: 20px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 10px;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #2c73d2;
}

.form-group {
  margin-bottom: 15px;
}

label {
  font-weight: bold;
  display: block;
  margin-bottom: 6px;
}

input,
button {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #aaa;
  border-radius: 6px;
  font-size: 14px;
}

button {
  background-color: #2c73d2;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s;
}

button:hover {
  background-color: #1b365d;
}
</style>
